const data = {
  title: "Floor 3-7",
  musicTrack: "MUSIC_WORLD3",
  theme: "PINK",
  tilesWidth: 13,
  tilesHeight: 13,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 3,
      y: 3
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 11,
      y: 7
    },
    {
      type: "FIRE",
      x: 9,
      y: 8
    },
    {
      type: "FIRE",
      x: 1,
      y: 6
    },
    {
      type: "FIRE",
      x: 1,
      y: 5
    },
    {
      type: "FIRE",
      x: 1,
      y: 4
    },
    {
      type: "FIRE",
      x: 1,
      y: 3
    },
    {
      type: "FIRE",
      x: 1,
      y: 2
    },
    {
      type: "FIRE",
      x: 1,
      y: 1
    },
    {
      type: "FIRE",
      x: 2,
      y: 1
    },
    {
      type: "FIRE",
      x: 3,
      y: 1
    },
    {
      type: "FIRE",
      x: 4,
      y: 1
    },
    {
      type: "FIRE",
      x: 5,
      y: 1
    },
    {
      type: "FIRE",
      x: 6,
      y: 1
    },
    {
      type: "FIRE",
      x: 7,
      y: 1
    },
    {
      type: "FIRE",
      x: 8,
      y: 1
    },
    {
      type: "FIRE",
      x: 9,
      y: 1
    },
    {
      type: "FIRE",
      x: 10,
      y: 1
    },
    {
      type: "FIRE",
      x: 11,
      y: 1
    },
    {
      type: "FIRE",
      x: 12,
      y: 1
    },
    {
      type: "FIRE",
      x: 13,
      y: 1
    },
    {
      type: "FIRE",
      x: 13,
      y: 2
    },
    {
      type: "FIRE",
      x: 5,
      y: 2
    },
    {
      type: "FIRE",
      x: 13,
      y: 4
    },
    {
      type: "FIRE",
      x: 5,
      y: 5
    },
    {
      type: "FIRE",
      x: 2,
      y: 5
    },
    {
      type: "FIRE",
      x: 4,
      y: 5
    },
    {
      type: "FIRE",
      x: 1,
      y: 7
    },
    {
      type: "FIRE",
      x: 1,
      y: 8
    },
    {
      type: "FIRE",
      x: 1,
      y: 9
    },
    {
      type: "FIRE",
      x: 2,
      y: 9
    },
    {
      type: "FIRE",
      x: 4,
      y: 9
    },
    {
      type: "FIRE",
      x: 5,
      y: 9
    },
    {
      type: "FIRE",
      x: 9,
      y: 10
    },
    {
      type: "FIRE",
      x: 6,
      y: 5
    },
    {
      type: "FIRE",
      x: 8,
      y: 5
    },
    {
      type: "FIRE",
      x: 9,
      y: 5
    },
    {
      type: "FIRE",
      x: 10,
      y: 5
    },
    {
      type: "FIRE",
      x: 13,
      y: 5
    },
    {
      type: "FIRE",
      x: 12,
      y: 5
    },
    {
      type: "FIRE",
      x: 13,
      y: 6
    },
    {
      type: "FIRE",
      x: 13,
      y: 7
    },
    {
      type: "FIRE",
      x: 13,
      y: 8
    },
    {
      type: "FIRE",
      x: 9,
      y: 6
    },
    {
      type: "FIRE",
      x: 6,
      y: 9
    },
    {
      type: "FIRE",
      x: 8,
      y: 9
    },
    {
      type: "FIRE",
      x: 12,
      y: 9
    },
    {
      type: "FIRE",
      x: 13,
      y: 9
    },
    {
      type: "FIRE",
      x: 1,
      y: 10
    },
    {
      type: "FIRE",
      x: 1,
      y: 11
    },
    {
      type: "FIRE",
      x: 1,
      y: 12
    },
    {
      type: "FIRE",
      x: 1,
      y: 13
    },
    {
      type: "FIRE",
      x: 2,
      y: 13
    },
    {
      type: "FIRE",
      x: 3,
      y: 13
    },
    {
      type: "FIRE",
      x: 4,
      y: 13
    },
    {
      type: "FIRE",
      x: 5,
      y: 13
    },
    {
      type: "FIRE",
      x: 13,
      y: 10
    },
    {
      type: "FIRE",
      x: 13,
      y: 12
    },
    {
      type: "FIRE",
      x: 13,
      y: 13
    },
    {
      type: "FIRE",
      x: 12,
      y: 13
    },
    {
      type: "FIRE",
      x: 11,
      y: 13
    },
    {
      type: "FIRE",
      x: 10,
      y: 13
    },
    {
      type: "FIRE",
      x: 9,
      y: 13
    },
    {
      type: "FIRE",
      x: 8,
      y: 13
    },
    {
      type: "FIRE",
      x: 6,
      y: 13
    },
    {
      type: "FIRE",
      x: 5,
      y: 10
    },
    {
      type: "FIRE",
      x: 5,
      y: 12
    },
    {
      type: "FIRE",
      x: 9,
      y: 12
    },
    {
      type: "FIRE",
      x: 10,
      y: 9
    },
    {
      type: "WATER",
      x: 12,
      y: 2
    },
    {
      type: "WATER",
      x: 11,
      y: 2
    },
    {
      type: "WATER",
      x: 10,
      y: 2
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 3,
      direction: "RIGHT"
    },
    {
      type: "CONVEYOR",
      x: 11,
      y: 5,
      direction: "DOWN"
    },
    {
      type: "CONVEYOR",
      x: 9,
      y: 7,
      direction: "LEFT"
    },
    {
      type: "CONVEYOR",
      x: 3,
      y: 9,
      direction: "DOWN"
    },
    {
      type: "CONVEYOR",
      x: 11,
      y: 9,
      direction: "UP"
    },
    {
      type: "FIRE",
      x: 5,
      y: 4
    },
    {
      type: "WATER",
      x: 12,
      y: 3
    },
    {
      type: "WATER",
      x: 12,
      y: 4
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 9,
      direction: "UP"
    },
    {
      type: "WATER",
      x: 10,
      y: 3
    },
    {
      type: "WATER",
      x: 11,
      y: 4
    },
    {
      type: "WATER",
      x: 10,
      y: 4
    },
    {
      type: "WATER",
      x: 11,
      y: 3
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 5,
      direction: "UP"
    },
    {
      type: "THIEF",
      x: 9,
      y: 3
    },
    {
      type: "FIRE",
      x: 9,
      y: 2
    },
    {
      type: "FIRE",
      x: 9,
      y: 4
    },
    {
      type: "FIRE_BOOTS",
      x: 7,
      y: 3
    },
    {
      type: "ICE",
      x: 6,
      y: 3
    },
    {
      type: "ICE",
      x: 7,
      y: 3
    },
    {
      type: "ICE",
      x: 7,
      y: 4
    },
    {
      type: "ICE",
      x: 6,
      y: 4
    },
    {
      type: "ICE",
      x: 8,
      y: 4
    },
    {
      type: "ICE",
      x: 8,
      y: 3
    },
    {
      type: "ICE",
      x: 6,
      y: 2
    },
    {
      type: "ICE",
      x: 7,
      y: 2
    },
    {
      type: "ICE",
      x: 8,
      y: 2
    },
    {
      type: "CONVEYOR",
      x: 3,
      y: 5,
      direction: "DOWN"
    },
    {
      type: "CHIP",
      x: 7,
      y: 11
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 8,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 7,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 6,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 7,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 12,
      y: 8,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 8,
      isRaised: true
    },
    {
      type: "ENEMY_SPAWN",
      x: 1,
      y: 5,
      direction: "RIGHT",
      enemyType: "FLYING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 13,
      y: 9,
      direction: "LEFT",
      enemyType: "FLYING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 9,
      y: 1,
      direction: "DOWN",
      enemyType: "FLYING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 13,
      direction: "UP",
      enemyType: "FLYING_ENEMY"
    },
    {
      type: "WATER",
      x: 10,
      y: 12
    },
    {
      type: "WATER",
      x: 11,
      y: 12
    },
    {
      type: "WATER",
      x: 12,
      y: 12
    },
    {
      type: "WATER",
      x: 12,
      y: 11
    },
    {
      type: "WATER",
      x: 11,
      y: 11
    },
    {
      type: "WATER",
      x: 10,
      y: 11
    },
    {
      type: "WATER",
      x: 10,
      y: 10
    },
    {
      type: "WATER",
      x: 11,
      y: 10
    },
    {
      type: "WATER",
      x: 12,
      y: 10
    },
    {
      type: "CONVEYOR",
      x: 9,
      y: 11,
      direction: "UP"
    },
    {
      type: "SWITCH",
      x: 9,
      y: 9
    },
    {
      type: "WATER_PICKUP",
      x: 13,
      y: 7
    },
    {
      type: "WATER",
      x: 2,
      y: 10
    },
    {
      type: "WATER",
      x: 2,
      y: 11
    },
    {
      type: "WATER",
      x: 2,
      y: 12
    },
    {
      type: "WATER",
      x: 3,
      y: 12
    },
    {
      type: "WATER",
      x: 4,
      y: 12
    },
    {
      type: "WATER",
      x: 4,
      y: 11
    },
    {
      type: "WATER",
      x: 3,
      y: 11
    },
    {
      type: "WATER",
      x: 3,
      y: 10
    },
    {
      type: "WATER",
      x: 4,
      y: 10
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 11,
      direction: "LEFT"
    },
    {
      type: "ICE",
      x: 6,
      y: 10
    },
    {
      type: "ICE",
      x: 6,
      y: 11
    },
    {
      type: "ICE",
      x: 6,
      y: 12
    },
    {
      type: "ICE",
      x: 7,
      y: 12
    },
    {
      type: "ICE",
      x: 7,
      y: 10
    },
    {
      type: "ICE",
      x: 8,
      y: 10
    },
    {
      type: "ICE",
      x: 8,
      y: 11
    },
    {
      type: "ICE",
      x: 8,
      y: 12
    },
    {
      type: "CONVEYOR",
      x: 13,
      y: 3,
      direction: "UP"
    },
    {
      type: "ICE",
      x: 7,
      y: 11
    },
    {
      type: "CHIP",
      x: 11,
      y: 11
    },
    {
      type: "CHIP",
      x: 3,
      y: 11
    },
    {
      type: "ICE",
      x: 4,
      y: 7
    },
    {
      type: "ICE",
      x: 5,
      y: 7
    },
    {
      type: "ICE",
      x: 6,
      y: 7
    },
    {
      type: "ICE",
      x: 8,
      y: 8
    },
    {
      type: "ICE",
      x: 7,
      y: 6
    },
    {
      type: "ICE",
      x: 8,
      y: 6
    },
    {
      type: "ICE",
      x: 6,
      y: 6
    },
    {
      type: "ICE",
      x: 5,
      y: 6
    },
    {
      type: "ICE",
      x: 4,
      y: 6
    },
    {
      type: "KEY",
      x: 2,
      y: 2,
      color: "BLUE"
    },
    {
      type: "ICE",
      x: 3,
      y: 7
    },
    {
      type: "ICE",
      x: 2,
      y: 7
    },
    {
      type: "LOCK",
      x: 3,
      y: 8,
      color: "BLUE"
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 7,
      direction: "UP"
    },
    {
      type: "ICE",
      x: 8,
      y: 7
    },
    {
      type: "ICE",
      x: 6,
      y: 8
    },
    {
      type: "ICE",
      x: 5,
      y: 8
    },
    {
      type: "ICE",
      x: 4,
      y: 8
    },
    {
      type: "ICE",
      x: 3,
      y: 6
    },
    {
      type: "ICE",
      x: 2,
      y: 6
    },
    {
      type: "ICE",
      x: 2,
      y: 8
    },
    {
      type: "LOCK",
      x: 7,
      y: 8,
      color: "GREEN"
    },
    {
      type: "KEY",
      x: 1,
      y: 9,
      color: "GREEN"
    },
    {
      type: "CONVEYOR",
      x: 13,
      y: 11,
      direction: "LEFT"
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 13,
      direction: "RIGHT"
    },
    {
      type: "ICE_BOOTS",
      x: 11,
      y: 3
    }
  ]
};

export default data;
